import { ComputedRef } from 'vue';
import { getPersonalInterfacesTaskLog } from '@/store/modules/analytics/actions.js';
import { InterfaceLogDetails } from '@/components/InterfacesLogs/interfaces-logs-types';
import { usePersonalInterfacesTaskDetails } from '@/store/modules/analytics/getters.js';
import { StoreAction, StoreGetter, mapAction, mapComputedGetter } from '@/store/utils/mappers';
export const useInterfacesLogs = () =>
	<UseInterfacesLogs>{
		getPersonalInterfacesTaskLog: (taskLogId) => mapAction(getPersonalInterfacesTaskLog as StoreAction)({ taskLogId }),
		personalInterfaceTaskLogDetails: (taskLogId) => mapComputedGetter(usePersonalInterfacesTaskDetails as StoreGetter).value(taskLogId),
	};

interface UseInterfacesLogs {
	getPersonalInterfacesTaskLog: (taskLogId: string) => void;
	personalInterfaceTaskLogDetails: (taskLogId: string) => ComputedRef<InterfaceLogDetails[]>;
}
